export const iconFontAwesomeSocialSquareShareNodes = (
	<i className="fa-solid fa-square-share-nodes"></i>
);
